import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Download, Building2, Users, Contact, ChevronDown } from "lucide-react";

async function download(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], filename.endsWith(".vcf") ? { type: "text/vcard" } : undefined));
    const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 30000);
  } catch { toast.error("Export failed"); }
}

export function ExportMenu({ kind, selected }) {
  const ids = [...(selected || [])];
  const n = ids.length;
  const q = n ? `ids=${ids.join(",")}` : "";
  const day = new Date().toISOString().slice(0, 10);
  const one = kind === "clients" ? "client" : "supplier";
  const scope = n ? `${n} selected` : `all ${kind}`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid={`export-${kind}-menu`} title={`Export ${scope}`}>
          <Download className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">{n ? `Export (${n})` : "Export"}</span>{n > 0 && <span className="ml-1 rounded-full bg-[#1B4383] px-1.5 text-[10px] font-semibold text-white sm:hidden" data-testid={`export-${kind}-count`}>{n}</span>}<ChevronDown className="ml-1 h-3.5 w-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground" data-testid={`export-${kind}-scope`}>Exporting {scope}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => download(`/${kind}/export?${q}`, `somcore_${kind}_${day}.xlsx`)} data-testid={`export-${kind}-companies`}><Building2 className="mr-2 h-4 w-4" />Companies To Excel</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download(`/crm/contacts/export?kind=${kind}&${q}`, `somcore_${one}_contacts_${day}.xlsx`)} data-testid={`export-${kind}-people`}><Users className="mr-2 h-4 w-4" />People To Excel</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download(`/crm/contacts.vcf?kind=${kind}&${q}`, `somcore_${one}_contacts.vcf`)} data-testid={`export-${kind}-vcf`}><Contact className="mr-2 h-4 w-4" />People To Phone Contacts</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
